// export const config = {
//   hubUrl: 'http://hubculture.local',
//   baseURL: 'http://id-hubculture.dev-test.pro',
//   PublicKey: 'public_9109bcce5347b73c32e419313',
//   PrivateKey: 'private_6aae21a391fd7d1ee7c5d8d4'
// }
export const config = {
  PrivateKey: 'private_5c05bd74e4ef06698f644827',
  PublicKey: 'public_1fa6ff4bbf33baf8da77c7e9b',
  baseURL: 'https://id.hubculture.com'
}
